// extracted by mini-css-extract-plugin
export default {"root":"BrokerChart_root__nf5-2","root_data":"BrokerChart_root_data__jhOaS"};